import React from "react";
import styled from "styled-components";

import { ConfirmBox } from "./ConfirmBox";
import { IPWhiteListInfoCard } from "./IPWhiteListInfoCard";

const StyledConfirmBox = styled(ConfirmBox)`
  .ant-modal-content {
    .ant-modal-header {
      .ant-modal-title {
        margin-right: 24px;
      }
    }

    .ant-modal-body {
      padding: 8px 24px;
    }

    .ant-modal-footer {
      padding: 8px 24px 16px;

      .submit {
        width: 100%;
      }
    }
  }
`;

type IPWhitelistInfoPopupProps = {
  setShowIPWhiteListInfoPopup: (arg: boolean) => void;
  dataSourceType: string;
  faqLink?: string;
  onClickFaqLink?: () => void;
};

export const IPWhitelistInfoPopup: React.FC<IPWhitelistInfoPopupProps> = ({
  setShowIPWhiteListInfoPopup,
  dataSourceType,
  faqLink,
  onClickFaqLink,
}) => {
  return (
    <StyledConfirmBox
      closable={true}
      visible={true}
      showSubmit={true}
      onSubmit={() => setShowIPWhiteListInfoPopup(false)}
      showCancel={false}
      onCancel={() => setShowIPWhiteListInfoPopup(false)}
      submitText={"Got it"}
      title="Is your database behind a firewall or private network?"
    >
      <IPWhiteListInfoCard
        dataSourceType={dataSourceType}
        noMargin={true}
        faqLink={faqLink}
        onClickFaqLink={onClickFaqLink}
      />
    </StyledConfirmBox>
  );
};
